import 'whatwg-fetch'
import 'intersection-observer'
import { polyfill } from 'es6-promise'
import $ from 'jquery'
import smoothscroll from 'smoothscroll-polyfill'
import Vue from 'vue'
import VueMq from 'vue-mq'
import VueObserveVisibility from 'vue-observe-visibility'
import TurbolinksAdapter from 'vue-turbolinks'
import Law from '../vue/law.vue'

polyfill()
smoothscroll.polyfill()
window.$ = $
window.jQuery = $
window.Vue = Vue

Vue.use(VueObserveVisibility)
Vue.use(TurbolinksAdapter)
Vue.use(VueMq, {
  breakpoints: {
    small: 640,
    medium: 1024,
    large: 1200,
    xlarge: 1440,
    xxlarge: Infinity
  }
})

Vue.config.performance = true

document.addEventListener('turbolinks:load', mountLaw)
$(document).ready(mountLaw)

function mountLaw() {
  const element = document.getElementById('vuelaw')
  if (element) {
    new Vue({
      el: element,
      render: createElement => createElement(Law)
    })
  }
}
